import { formConstants } from '../../../../utils/constants/form-constants';
import {
    getFileStates,
    getPaymentStatuses,
    getOrderTypes,
    getActionOrderTypes
} from './account-form-data-utils';
import { formMessageConstants } from '../../../../utils/constants/form-message-constants';

const AccountHomePageFormData = (
    {
        ssoAccountHomePageFields,
        ssoOrderHistoryFields,
        getHomePageTicketsDataCallbackUrl,
        ssoDomain
    }
) => {
    function buildAccountHomePageFormData() {
        const formData = {};
        const {
            formTitle,
            formSubTitle,
            showParkingButton,
            showParkingButtonText,
            showExpiryDate,
            secuTixErrorMessage,
            parkingButtonUrl,
            loadingErrorMessage,
            elapsedTimeLimit,
        } = ssoAccountHomePageFields;

        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.formSubTitle] = formSubTitle;
        formData[formConstants.getHomePageTicketsDataCallbackUrl] = getHomePageTicketsDataCallbackUrl;
        formData[formConstants.secuTixErrorMessage] = secuTixErrorMessage;
        formData[formConstants.loadingErrorMessage] = loadingErrorMessage;
        formData[formConstants.elapsedTimeLimit] = elapsedTimeLimit;
        formData[formConstants.fileState] = getFileStates(ssoOrderHistoryFields);
        formData[formConstants.paymentStatus] = getPaymentStatuses(ssoOrderHistoryFields);
        formData[formConstants.orderType] = getOrderTypes(ssoOrderHistoryFields);
        formData[formConstants.actionOrderType] = getActionOrderTypes(ssoAccountHomePageFields);
        formData[formConstants.noOrdersFoundText] = ssoOrderHistoryFields.noOrdersFoundText || formMessageConstants.noOrdersFoundText;
        formData[formConstants.noActionsToPerformText] = ssoOrderHistoryFields.noActionsToPerformText || formMessageConstants.noActionsToPerformText;
        formData[formConstants.noUpcomingEventText] = ssoOrderHistoryFields.noUpcomingEventText || formMessageConstants.noUpcomingEventText;
        formData[formConstants.ssoDomain] = ssoDomain;
        formData[formConstants.showExpiryDate] = showExpiryDate;
        formData[formConstants.showParkingButton] = showParkingButton;
        formData[formConstants.showParkingButtonText] = showParkingButtonText;
        formData[formConstants.parkingButtonUrl] = parkingButtonUrl;
        return formData;
    }

    return buildAccountHomePageFormData();
};

export default AccountHomePageFormData;
